/**
 * Public contact details shown to visitors (US-059 / MV-370).
 *
 * No phone number on purpose: nobody can promise to answer calls yet (MV-364).
 * `whatsappUrl` stays empty until a dedicated WhatsApp Business number exists.
 * While it is empty the WhatsApp button shows as a non-clickable preview on
 * local and dev builds only, and production hides it (see whatsappMode()).
 */
export const CONTACT = {
  email: 'care@medicvoy.com',
  whatsappUrl: '',
} as const;

/**
 * 'live'    — a real WhatsApp link is configured: show it everywhere.
 * 'preview' — no link yet, non-production build: show the button so the design
 *             can be reviewed, but it does nothing.
 * 'off'     — no link yet, production build: hide it.
 */
export function whatsappMode(production: boolean): 'live' | 'preview' | 'off' {
  if (CONTACT.whatsappUrl) return 'live';
  return production ? 'off' : 'preview';
}
